import React, {Component} from "react";
import PropTypes from 'prop-types'
import Tooltip from "@mui/material/Tooltip";
import "./StyleSheets.css"

export class MyTooltip extends Component {

    render() {
        const {title, isArrow, position, maxWidth} = this.props

        return (
            position ?
                <Tooltip arrow={isArrow} maxWidth={maxWidth} title={title} placement={position} enterTouchDelay={0}>
                    {this.props.children}
                </Tooltip>
                :

                <Tooltip arrow={isArrow} title={title} enterTouchDelay={0}>
                    {this.props.children}
                </Tooltip>
        )
    }
}

MyTooltip.defaultProps = {
    title: "sample",
    isArrow: true,
    tooltipType: "normal",
    position: "",
    maxWidth: 900
}


MyTooltip.propTypes = {
    title: PropTypes.string.isRequired,
    isArrow: PropTypes.bool,
    maxWidth: PropTypes.number,
    tooltipType: PropTypes.oneOf(["error", "warning", "normal", "information"]).isRequired,
    position: PropTypes.oneOf(['', 'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top']).isRequired
}
